import HTTPClient from './http-client';

const options = {
  cache: {
    maxAge: 60 * 60 * 1000,
    exclude: { query: false }
  }
}

const END_POINT = '/landuse_overview';

const loadLandUseOverview = async (locacronymn) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}?name=${locacronymn}`,
    options
  );
}

export {
  loadLandUseOverview
}
